export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13393.47806df0.jpg";